'use strict'

module.exports = class BrowseWidgetModel extends Backbone.Model
  url: '/browse/search/widget'